import { useTranslation } from 'react-i18next';
import Constants from 'style/constants';
import MonitoringAlert from 'shared/components/monitoring/monitoring-alert/monitoring-alert';
import { MonitoringType } from 'shared/components/monitoring/monitoring-type';

import { Connector, ConnectorStatus } from 'features/connectors/domain/connector';

interface IProps {
  connector?: Connector;
}

const ConnectorMonitoringAlert = ({ connector }: IProps) => {
  const { t } = useTranslation('monitoring');

  const getAlert = (connector?: Connector) => {
    if (!connector?.status) {
      return null;
    }

    if (connector.status === ConnectorStatus.offline) {
      return (
        <MonitoringAlert
          key="connector-offline"
          text={t('messages.connectorOffline')}
          type={MonitoringType.ConnectorOffline}
          color={Constants.Colors.error}
        />
      );
    }

    return null;
  };

  return getAlert(connector) || <></>;
};

export default ConnectorMonitoringAlert;
